module.exports = __webpack_public_path__ + "static/media/background.fa1def9d.jpg";